import { forwardRef } from "react";
function SvgRawCheckIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m6 13 4 6 8-14"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawCheckIcon);
export default ForwardRef;
